import { render } from "./DirectionGenerate&History.vue?vue&type=template&id=dffe02ca"
import script from "./DirectionGenerate&History.vue?vue&type=script&lang=js"
export * from "./DirectionGenerate&History.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__